import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@chakra-ui/react';
import { formatAssetsUrl, akamaiImageLoader, isIVMEnabled } from '@whitbread-eos/utils';
import Image from 'next/image';
import HotelBrandLogo from '../HotelBrandLogo/HotelBrandLogo.component';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HotelThumbnail(_ref) {
  var imageData = _ref.imageData,
    brand = _ref.brand,
    brandLogos = _ref.brandLogos,
    testId = _ref.testId,
    styles = _ref.styles,
    eagerLoad = _ref.eagerLoad;
  return _jsxs(Box, _objectSpread(_objectSpread({
    position: "relative"
  }, styles), {}, {
    "data-testid": testId,
    children: [_jsx(Image, {
      src: formatAssetsUrl(imageData.imageSrc),
      alt: imageData.imageAlt,
      fill: true,
      style: {
        objectFit: 'fill'
      },
      sizes: "(max-width: 575px) 575px, (min-width: 576px && max-width: 767px) 120px, (min-width: 768px) 188px",
      loader: isIVMEnabled() ? akamaiImageLoader : undefined,
      priority: !!eagerLoad
    }), _jsx(HotelBrandLogo, {
      logos: brandLogos,
      brand: brand
    })]
  }));
}